import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/image/article.png';
const _withScopeId = n => (_pushScopeId("data-v-442470d5"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "liuhe"
};
const _hoisted_2 = {
  class: "tk-swiper",
  style: {
    "margin-top": "10px"
  }
};
const _hoisted_3 = {
  class: "tk-materals-list"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "tk-list-title"
};
const _hoisted_6 = {
  class: "tk-title-picture"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "tk-title-info"
};
const _hoisted_9 = {
  class: "tk-name"
};
const _hoisted_10 = {
  class: "tk-tiems"
};
const _hoisted_11 = {
  class: "tk-list-content"
};
const _hoisted_12 = {
  class: "tk-exit"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_14 = [_hoisted_13];
import { reactive, toRefs } from "vue";
import { useStore } from 'vuex';
import { discussList } from '@/utils/https/master';
import { loadingProps } from "vant";

import { onBeforeMount, ref } from 'vue';
import { useRouter } from 'vue-router';
export default {
  __name: 'liuhe',
  setup(__props) {
    const $store = useStore(); //获取vuex

    let data = reactive({
      adList: [],
      articleData: [],
      lottery: localStorage.getItem('lotteryType'),
      page: 1,
      websiteName: JSON.parse(localStorage.getItem('config')) == null ? {
        logo: ''
      } : JSON.parse(localStorage.getItem('config')),
      keyword: ''
    });
    let {
      articleData,
      websiteName
    } = toRefs(data);
    onBeforeMount(() => {
      data.adList = JSON.parse(localStorage.getItem('avList')).adlist;
    });
    let discuss = (lottery, type, sort = '1', page) => {
      discussList({
        lotteryType: lottery,
        type: type,
        sort: sort,
        page: page,
        cate: 2,
        keyword: data.keyword
      }).then(res => {
        if (res == undefined) return false;
        if (res.data.status == 40000) {
          finished.value = true;
        } else {
          let datas = res.data.data.data;
          datas.forEach(item => {
            item.content = item.content.replace(/\n/g, "<br>");
            item.nickname = item.user.nickname;
          });
          loading.value = false;
          data.articleData.push(...datas);
        }
      });
    };
    let onSubmit = item => {
      data.articleData.length = 0;
      data.page = 1;
      data.keyword = item;
      discuss(data.lottery, 1, 4, data.page);
    };
    const loading = ref(false);
    const finished = ref(false);
    const onLoad = () => {
      discuss(data.lottery, 1, 4, data.page);
      data.page++;
    };
    let router = useRouter();
    let majorArticle = () => {
      //跳转发布
      router.push({
        path: '/master/release',
        query: {
          cate: '2',
          lottery: data.lottery
        }
      });
    };
    let majorDesc = item => {
      router.push({
        path: '/master/details',
        query: {
          id: item.id
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_headNav = _resolveComponent("headNav");
      const _component_swipers = _resolveComponent("swipers");
      const _component_search = _resolveComponent("search");
      const _component_empty = _resolveComponent("empty");
      const _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_headNav, {
        title: "六合公式"
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_swipers, {
        swiperImg: _unref(data).adList
      }, null, 8, ["swiperImg"])]), _createVNode(_component_search, {
        returns: false,
        onOnSubmit: _unref(onSubmit)
      }, null, 8, ["onOnSubmit"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_list, {
        loading: _unref(loading),
        "onUpdate:loading": _cache[0] || (_cache[0] = $event => _isRef(loading) ? loading.value = $event : null),
        finished: _unref(finished),
        "finished-text": "",
        onLoad: onLoad
      }, {
        default: _withCtx(() => [_unref(articleData).length == 0 ? (_openBlock(), _createBlock(_component_empty, {
          key: 0
        })) : _createCommentVNode("", true), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(articleData), (item, index) => {
          return _openBlock(), _createElementBlock("li", {
            onClick: $event => _unref(majorDesc)(item),
            key: index
          }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
            src: _unref(websiteName).host + item.user.avatar,
            alt: ""
          }, null, 8, _hoisted_7)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.nickname), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(item.created_at), 1)])]), _createElementVNode("div", _hoisted_11, _toDisplayString(item.title), 1)], 8, _hoisted_4);
        }), 128))])]),
        _: 1
      }, 8, ["loading", "finished"])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
        class: "tk-icon",
        onClick: _cache[1] || (_cache[1] = (...args) => _unref(majorArticle) && _unref(majorArticle)(...args))
      }, _hoisted_14)])], 64);
    };
  }
};